import React from "react"

import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"

import {Wrapper, PollIcon, Paragraph} from "./styled/Feed"

const EmptyFeed = () => {
  const tenant = authentication.userTenant()

  return (
    <Wrapper>
      <PollIcon />
      <Paragraph>
        <FormattedMessage id="recognition.polls.empty.feed.p1" values={{tenantName: tenant.public_name}} />
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="recognition.polls.empty.feed.p2" />
      </Paragraph>
    </Wrapper>
  )
}

export default EmptyFeed
